import * as React from "react";

function SvgCloud(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M13.14 13.14H3.43a3.43 3.43 0 110-6.85h.16a4.56 4.56 0 019 1.13h.57a2.86 2.86 0 110 5.71z" fill="currentColor" /></svg>;
}

const ForwardRef = React.forwardRef(SvgCloud);
export default ForwardRef;